import type { PipelineDoc, PlannedPipeline } from './types';
import { contentPipeline } from './content';
import { audioPipeline } from './audio';

/**
 * Registry der beschriebenen Strecken (CUR-1571).
 *
 * Eine weitere Pipeline zu ergaenzen ist eine Datei plus ein Eintrag hier —
 * keine Komponentenarbeit. Genau dafuer traegt `PipelineDoc` die Struktur.
 */
export const PIPELINES: PipelineDoc[] = [contentPipeline, audioPipeline];

export function findPipeline(slug: string | undefined): PipelineDoc | undefined {
  return PIPELINES.find((p) => p.slug === slug);
}

/**
 * Strecken, die es gibt, die hier aber noch nicht beschrieben sind. Sie stehen
 * bewusst sichtbar auf der Uebersicht: eine ausgegraute Karte sagt ehrlicher
 * "noch nicht geschrieben" als eine stillschweigende Luecke.
 */
export const PLANNED: PlannedPipeline[] = [
  {
    slug: 'bilder',
    title: 'Bild-Pipeline',
    teaser: 'Beschaffung aus offen lizenzierten medizinischen Bildsammlungen, automatische Aussortierung, Zuordnung je Lektion.',
  },
  {
    slug: 'video',
    title: 'Video-Pipeline',
    teaser: 'Erklärvideos und Wissensclips: Skript mit Silbenbudget, Fach-Review, Standbilder, Bewegung, Vertonung, Montage.',
  },
  {
    slug: 'blog',
    title: 'Blog-Pipeline',
    teaser: 'Vier Stufen vom Monatsplan über Gliederung und Entwurf bis zur Prüfung gegen Heilmittelwerberecht und Quellenlage.',
  },
  {
    slug: 'social',
    title: 'Social-Redaktion',
    teaser: 'Redaktionskalender, Rhythmen und Bestand — geplant als eigenes Redaktionssystem.',
  },
];

export type { PipelineDoc, PlannedPipeline } from './types';
